<template>
  <div v-if="show" id="app">
    <router-view />
    <!-- 密码修改 -->
    <EditPassword />
    <!-- 账号状态弹窗 -->
    <AccountStatusDialog />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import EditPassword from "@/components/EditPassword";
import AccountStatusDialog from "@/components/AccountStatusDialog";
import { tokenLogin } from "@/api/base";
import getBrowserFinger from "device-key";
import { getSysConfigInfo } from "@/api/home";
import { getIsLogin, setIsLogin } from "@/utils/loginStorage";

export default {
  components: {
    EditPassword,
    AccountStatusDialog
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapGetters("companyInfo", ["noLoginLook", "companyInfo"])
  },
  watch: {
    noLoginLook() {
      if (!this.noLoginLook) {
        if (!getIsLogin()) {
          this.$router.replace({
            path: "/login"
          });
        }
      }
    },
    companyInfo() {
      // 不允许非正式客户访问 && 未登录
      if (!this.companyInfo.setting.allowInformalCustomer && !getIsLogin()) {
        // 跳转登录页面
        this.$router.replace({
          path: "/login"
        });
      }
    }
  },
  created() {
    this.getVersionThemeColor();
    if (window.token) {
      this.tokenLoginFn();
    } else {
      this.show = true;
    }
  },
  methods: {
    ...mapActions("theme", ["updatePrimaryColor"]),
    //获取版本号和主题色
    async getVersionThemeColor() {
      try {
        const res = await getSysConfigInfo(true);
        this.updatePrimaryColor(res.themeColor);
        // this.$store.$emit("")
        this.$store.commit("theme/SET_PRIMARY_COLOR", res.themeColor);
      } catch (error) {}
    },
    async tokenLoginFn() {
      let device = "";
      const res = await Promise.all([getBrowserFinger()]);
      if (res && res.length) {
        device = res[0];
      }
      const data = {
        token: window.token, // 登录token
        type: 1, // 设备平台类型 web:1/app:2/h5:3
        device: device, // 设备号
        system: "" // 系统
      };
      tokenLogin(data)
        .then(res => {
          window.token = "";
          if (res) {
            // 商家端登录
            window.location.href = `${window.location.origin}/seller`;
          } else {
            setIsLogin(true);
            window.location.replace("/");
          }
        })
        .catch(err => {
          this.show = true;
          window.token = "";
          this.$message.error(err.message || "登录失败！");
          this.$router.replace({
            path: "/login"
          });
        });
    }
  }
};
</script>

<style lang="less">
@import "/src/assets//css/style/index.less";
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333333;
  width: 100%;
  height: 100vh;
}
.line-wrap {
  display: -webkit-box;
  // -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all; /* 可选：处理长单词换行 */
}
// .w-e-text table {
//   border-top: 1px solid #ccc;
//   border-left: 1px solid #ccc;
// }
// .w-e-text table th {
//   border-bottom: 2px solid #ccc;
//   text-align: center;
//   background-color: #f1f1f1;
// }
// .w-e-text h5 {
//   margin: 10px 0;
//   line-height: 1.5;
// }
// .w-e-text table td,
// .w-e-text table th {
//   border-bottom: 1px solid #ccc;
//   border-right: 1px solid #ccc;
//   padding: 3px 5px;
//   min-height: 30px;
//   height: 30px;
// }
</style>
